import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '50vh',
          padding: '48px 24px',
          textAlign: 'center',
          fontFamily: "'Jost', sans-serif",
          color: 'var(--warm)',
        }}>
          <h2 style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: '1.8rem',
            fontWeight: 400,
            marginBottom: 16,
          }}>
            Ceva nu a funcționat
          </h2>
          <p style={{ color: 'var(--muted)', marginBottom: 24, maxWidth: 400, lineHeight: 1.6 }}>
            A apărut o eroare neașteptată. Te rugăm să reîncerci.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary"
          >
            Reîncarcă pagina
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
